import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

const AppRoute = ({ children, requiredPermission }) => {
	const dispatch = useDispatch();
	const location = useLocation();
	const permission = useSelector((state) => state.Login.permissionArry);

	if (permission?.length > 0 && requiredPermission && !permission?.includes(requiredPermission)) {
		return <Navigate to="/not-authorized" />;
	}
	return (<React.Fragment>
		{children}
	</React.Fragment>);
}

export default AppRoute;

